module.exports = __webpack_public_path__ + "static/media/error-bco.cb09e4b9.svg";